import React, { useEffect, useRef } from "react";
import Footer from "./Footer.js";
import anime from 'animejs/lib/anime.es.js';

export function Pricing() {
    const animation = useRef(null);
    useEffect(() => {
        animation.current = anime({
          targets: '#pricing-table, #pricing-text',
          translateY: [100, 0],
          opacity: [0, 1],
          duration: 1500,
          loop: false,
          delay: anime.stagger(200),
          easing: "easeOutExpo"
        })
    }, [])
    return (
        <>
            <div id="main">
            <div id="free-review-container">
                <p>Your first Literature Review is <span style={{textDecoration: "underline"}}>Free!</span></p>
            </div>
            <div id="home-container">
            <h2 className="info-tite">Pricing</h2>
            <div id="home-animation">
            <div className="pricing-container">
            <table style={{ whiteSpace: "nowrap" }} id="pricing-table">
                <thead>
                    <tr>
                        <th>Item</th>
                        <th>Price</th>
                        <th>Occurrence</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Literature Review</td>
                        <td>$1.99</td>
                        <td>One-Time Purchase</td>
                    </tr>
                </tbody>
            </table>
            <div id="pricing-text">
            <p>We made our pricing model as simple as possible to avoid tricking users into paying for subscriptions or forcing users to buy items in bulk to avoid outrageous prices. With our one-time purchase model, you only pay for the literature reviews you want.</p>
            <p>Additionally, we have integrated <span>Stripe</span> as our payment processor so your sensitive payment details are never stored with us. You can rest assured that your purchase is secure and reliable every time.</p>
            <p><span>Plus, your first literature review is free!</span></p>
            </div>
            </div>
            </div>
            </div>
            </div>
            <Footer />
        </>
    )
}